import React, { useEffect, useState } from 'react'
import Popup from '../../../../components/popup/Popup'
import styles from "./ChangeScheduleDateModal.styles"
import HorizontalSeparator from '../../../../components/separator/horizontalSeparator/HorizontalSeparator'
import Button from '../../../../components/button/Button'
import { BUTTON_TYPE } from '../../../../components/button/constants'
import Loadable from '../../../../components/loadable/Loadable'
import { useDispatch, useSelector } from 'react-redux'
import { componentKey, setScheduleDate } from './ChangeScheduleDateModalSlice'
import { changeScheduleDateForAllVendor } from './ChangeScheduleDateModalSaga'
import useGarbageCollector from '../../../../../libs/garbagecollector/garbageCollectorHooks'
import CalendarInputWDateFormat from '../../../../components/input/calendarinput/CalendarInputWDateFormat'
import General from '../../../../../libs/utility/General'
import { componentKey as dataLoaderKey } from '../../../loaders/dataloader/DataLoaderSlice'
import DateUtils from '../../../../../libs/utility/DateUtils'
import moment from 'moment'
import ConfirmationPopup from '../../../../components/popup/confirmationpopup/ConfirmationPopup'
import { VEC_ICON_NAME } from '../../../../components/icons/constants'
import { addNotifications } from '../../../toaster/ToasterPortalSlice'
import { TOASTER_VARIANT } from '../../../../components/toast/constants'
import { EFILE_DEADLINE_DATE, FORM_NAMS } from '../constants'

const ChangeScheduleDateModal = ({
    isOpen,
    title = "Schedule Forms",
    onCloseCb,
    payerId,
    taxYearId,
    formId,
    formName = "",
    status = "NotSubmitted",
    ReadyToSubmitForms = [],
    onSubmitCb = null,
    inputLabel = "Select a date to schedule IRS/State eFiling",
}) => {
    useGarbageCollector(componentKey);

    const dispatch = useDispatch()

    const { loadingState, scheduleDate } = useSelector(state => state[componentKey]);
    const { formsScheduleDates } = useSelector(state => state[dataLoaderKey])

    const [showExtraChargWarnPopup, setShowExtraChargWarnPopup] = useState(false)
    const [selectedFormScheduleDetails, setSelectedFormScheduleDetails] = useState({})
    const [selectedFormEfileDeadline, setSelectedFormEfileDeadline] = useState(EFILE_DEADLINE_DATE)

    const onClickUpdate = () => {
        onSubmitCb ? onSubmitCb(scheduleDate) : dispatch(changeScheduleDateForAllVendor({ payerId, taxYearId, formId, status, ReadyToSubmitForms, scheduleDate }))
    }

    useEffect(() => {
        if (formName) {
            const scheduleDetails = formsScheduleDates?.formScheduleDates.find(form => (form.FormName === formName || General.removeDashesFromString(form.FormName) === formName))
            setSelectedFormScheduleDetails(scheduleDetails)
        }
    }, [formsScheduleDates, formName])


    useEffect(() => {
        if(formName === FORM_NAMS.$1099_NEC){
            setSelectedFormEfileDeadline(EFILE_DEADLINE_DATE)
        }else{
            setSelectedFormEfileDeadline(selectedFormScheduleDetails.ScheduledDate)
        }
    }, [formName, selectedFormScheduleDetails.ScheduledDate])

    const Body = (

        <Loadable
            currentState={loadingState.state}
            isNewLoadable={true}
            messageMap={[]}
        >
            <div style={styles.popupBody}>
                <CalendarInputWDateFormat
                    label={inputLabel}
                    value={scheduleDate}
                    inputClassName="w-100"
                    minAllowedDate={formsScheduleDates?.minScheduleDateAllowed && !General.isDateInPast(formsScheduleDates?.minScheduleDateAllowed) ? formsScheduleDates?.minScheduleDateAllowed : DateUtils.getMomentObject(new Date())}
                    onChangeCb={(e) => dispatch(setScheduleDate(e))}
                    allowOnlyFutureDate={true}
                    maxAllowedDate={DateUtils.getMomentObject(formsScheduleDates?.maxScheduleDateAllowed)}
                />

                <HorizontalSeparator />
                <div style={styles.footer}>
                    <Button
                        type={BUTTON_TYPE.PRIMARY}
                        style={styles.buttons}
                        onClickCb={() => {
                            if(scheduleDate){
                                if (moment(scheduleDate).isAfter(DateUtils.getMomentObject(selectedFormEfileDeadline), 'day')) {
                                    setShowExtraChargWarnPopup(true);
                                } else {
                                    onClickUpdate()
                                }
                            }else{
                                dispatch(addNotifications({ heading: "Warning", message: "Please select a date", variant: TOASTER_VARIANT.WARNING }))
                            }
                        }}
                    >
                        Update
                    </Button>

                    <Button
                        type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER}
                        style={styles.buttons}
                        onClickCb={onCloseCb}
                    >
                        Cancel
                    </Button>
                </div>
            </div>
        </Loadable>

    )

    return (
        <>
            <Popup
                isPopupOpen={isOpen}
                title={title}
                onCloseCb={onCloseCb}
                children={Body}
            />
            {showExtraChargWarnPopup ? <ConfirmationPopup
                showClose={false}
                title=''
                bodyText={`The IRS e-file deadline for the selected form is ${selectedFormEfileDeadline}. You have selected a scheduled e-file date after the deadline date. Please file form 8809 from your Dashboard, from the Forms > New Form menu, or via a paper filing after completing the form payment process for these selected forms. The IRS will grant a 30-day extension upon acceptance of your filing of form 8809. By clicking OK you agree to use the currently scheduled date, which is after the official deadline, and acknowledge by receipt of this notification that you must file form 8809 to receive an extension of time to e-file. If you do not wish to file an extension, please click Cancel and change the scheduled e-file date to ${selectedFormEfileDeadline} or earlier.`}
                bodyTextCustomStyle={{ fontSize: "12px" }}
                iconName={VEC_ICON_NAME.WARNING_ICON}
                isOpen={showExtraChargWarnPopup}
                confirmationButtonProps={{
                    onConfirmationCb: onClickUpdate,
                    confirmationButtonText: "Ok",
                    confirmationButtonStyles: {},
                    confirmationButtonType: BUTTON_TYPE.PRIMARY,
                }}
                cancelButtonProps={{
                    onCancelCb: () => setShowExtraChargWarnPopup(false),
                    cancelButtonText: "Cancel",
                    cancelButtonStyles: {},
                    cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                }}
            /> : null}
        </>
    )
}

export default ChangeScheduleDateModal